import _sfc_main from "./InputPC.vue2.mjs";
/* empty css              */
import normalizeComponent from "../../../../_virtual/_plugin-vue2_normalizer.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("div", { ref: "tuiInputRef", class: ["tui-input", _setup.themeClass, !_vm.border && "no-border"] }, [_c("input", { ref: "inputRef", style: _setup.inputStyle, attrs: { "placeholder": _vm.placeholder, "disabled": _vm.disabled, "maxlength": _setup.props.maxlength, "type": _setup.props.type, "enterkeyhint": _vm.enterkeyhint, "readonly": _vm.readonly, "autocomplete": "off" }, domProps: { "value": _vm.modelValue }, on: { "focus": _setup.focus, "blur": _setup.blur, "keyup": function($event) {
    if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
    return _setup.done.apply(null, arguments);
  }, "input": _setup.handleInput, "change": _setup.handleInput } }), _setup.hasSuffixIcon ? _c("div", { staticClass: "suffix-icon", on: { "mousedown": function($event) {
    $event.preventDefault();
  }, "click": _setup.handleSuffixIconClick } }, [_vm._t("suffixIcon")], 2) : _vm._e(), _setup.showResults ? _c("div", { staticClass: "results tui-theme-white" }, _vm._l(_setup.searchResult, function(item, index) {
    return _c("div", { key: index, staticClass: "results-item", on: { "mousedown": function($event) {
      $event.preventDefault();
    }, "click": function($event) {
      return _setup.handleResultItemClick(item);
    } } }, [_vm._v(" " + _vm._s(item.label || item.value) + " "), _vm._t("searchResultItem", null, { "data": item })], 2);
  }), 0) : _vm._e()]);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "bf51168a"
);
const InputPC = __component__.exports;
export {
  InputPC as default
};
